export default __webpack_public_path__ + "static/media/offer_ar.557924f5.png";